// extracted by mini-css-extract-plugin
export default {"wrapper":"auth_wrapper__1YMgR"};